import { Tag } from '@sharefile/tags-client';
import { LocaleString } from '../../../utils';
export enum LifecycleStage {
	active = 0,
	delete_pending = 1,
	draft = 2,
}

export enum RunDescriptionType {
	infoBox = 'infoBox',
}

export type TemplatePolicySet = {
	CanRead: boolean;
	CanWrite: boolean;
	CanDelete: boolean;
	CanShare: boolean;
};

export type TemplateActionSet = {
	details?: string;
};

export type RunDescription = {
	type: RunDescriptionType;
	properties: {
		content: LocaleString;
		buttonText?: LocaleString;
		buttonUrl?: string;
		pendoTrackingNamespace?: string;
	};
};

/**
 * A template information item.
 * @export
 * @interface TemplateInfo
 */
export type TemplateInfo = {
	id: string;
	RID: string;
	name: string;
	description?: string;
	overview?: string;
	containerRID: string;
	sourceRID?: string;
	created: string;
	creator: string;
	namespace?: string;
	rootType: string;
	lifecycleStage?: LifecycleStage;
	parameters?: any;
	policies: TemplatePolicySet;
	actions: TemplateActionSet;
	creationErrors?: string[];
	isLegacy?: boolean;
	isShared?: boolean;
	copyable?: boolean;
	originTemplate?: string;
	runDescription?: RunDescription;
};

export type CreateTemplateRunResponse = {
	id: string;
};

export type CopyTemplateParams = {
	RID: string;
	name?: string;
	description?: string;
	overview?: string;
};

export type CopyTemplateResponse = CreateTemplateRunResponse;

export type GetRunLogsParams = {
	executionId: string;
};

export type GetRunLogsResponse = RunLog[];

export type RunLog = {
	entry: {
		level: string;
		message: string;
		meta?: {
			[name: string]: any;
		};
	};
	timestamp: number;
};

export type StartEditResponse = {
	id: string;
};

/* Request Parameter types */
export type CreateTemplateParams = {
	definition: string;
};

export type CreateTemplateFromResourceParams = {
	resourceRID: string;
};

export type DeleteTemplateParams = {
	id: string;
};

export type GetTemplateParams = {
	id: string;
};

export type ListTemplatesParams = {
	parentRID?: string;
	rootType?: string;
	searchTerm?: string;
	filter?: (t: TemplateInfo) => boolean;
	enabled?: boolean;
	tags?: Tag[];
	includeHidden?: boolean;
};

export type CreateRunParams = {
	templateId: string;
	/**
	 * Container under which the resulting resource should get created (generally the account RID)
	 */
	parentRID: string;
	args?: object;
};

export type GetRunParams = {
	id: string;
};

export type ListRunsParams = {
	templateRID?: string;
};

export type ConstructTemplateParams = {
	RID: string;
	packageName: string;
	packageDescription?: string;
};

export type UpdateTemplateParams = {
	RID: string;
	name?: string;
	description?: string;
};

export type UpdateTemplateResponse = {};
